<script lang="ts">
  import { Col, Container, Form, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from "sveltestrap";
  import BookmarkDateTimePicker from "./BookmarkDateTimePicker.svelte";
  import Card from "../../../Core/Card.svelte";
  import { DateOnly, DateTimePicker, DisabledDaysoftheWeek, EnabledDisabledDates, MinimumSetup, NoIconinputfieldonly, TimeOnly, UsingLocales, ViewMode } from "../../../../utils/Constant/Constant";
  import { DateInput } from 'date-picker-svelte';
  let date:Date = new Date() ,mdate:Date = new Date() ,monthDate:Date = new Date()  
  let format:string = "HH:mm:ss"
  let selectDate:string = "dd-MM-yyyy"
</script>
<BookmarkDateTimePicker />
<Container fluid >
    <Card headerTitle={DateTimePicker}>
      <div slot="contentbody">
        <Row>
          <Col md="12">
            <div class="datetime-picker">
              <Form class="theme-form">
                <FormGroup>
                  <Row class="g-sm-3">
                    <Col sm="3">
                      <Label class="col-form-label text-end">{MinimumSetup}</Label>
                    </Col>
                    <Col xl="5" lg="8" sm="7">
                      <InputGroup>
                          <DateInput bind:value={date} />
                          <InputGroupText><i class="fa fa-calendar"> </i></InputGroupText>
                      </InputGroup>
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row class="g-sm-3">
                    <Col sm="3">
                      <Label class="col-form-label text-end">{UsingLocales}</Label>
                    </Col>
                    <Col xl="5" lg="8" sm="7">
                      <InputGroup>
                          <DateInput bind:value={mdate} />
                          <InputGroupText><i class="fa fa-calendar"> </i></InputGroupText>
                      </InputGroup>
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row class="g-sm-3">
                    <Col sm="3">
                      <Label class="col-form-label text-end">{TimeOnly}</Label>
                    </Col>
                    <Col xl="5" lg="8" sm="7">
                      <InputGroup>
                          <DateInput bind:value={date} {format}/>
                          <InputGroupText><i class="fa fa-clock-o"> </i></InputGroupText>
                      </InputGroup>
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row class="g-sm-3">
                    <Col sm="3">
                      <Label class="col-form-label text-end">{DateOnly}</Label>
                    </Col>
                    <Col xl="5" lg="8" sm="7">
                      <InputGroup>
                          <DateInput bind:value={date} format={selectDate}/>
                          <InputGroupText><i class="fa fa-calendar"> </i></InputGroupText>
                      </InputGroup>
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row class="g-sm-3">
                    <Col sm=3>
                      <Label class="col-form-label text-end">{NoIconinputfieldonly}</Label>
                    </Col>
                    <Col xl="5" lg="8" sm="7">
                      <DateInput bind:value={date} />
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row class="g-sm-3">
                    <Col sm="3">
                      <Label class="col-form-label text-end">{EnabledDisabledDates}</Label>
                    </Col>
                    <Col xl="5" lg="8" sm="7">
                      <InputGroup>
                          <DateInput bind:value={date} />
                          <InputGroupText><i class="fa fa-calendar"> </i></InputGroupText>
                      </InputGroup>
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row class="g-sm-3">
                    <Col sm="3">
                      <Label class="col-form-label text-end">{ViewMode}</Label>
                    </Col>
                    <Col xl="5" lg="8" sm="7">
                      <InputGroup>
                          <DateInput bind:value={date} />
                          <InputGroupText><i class="fa fa-calendar"> </i></InputGroupText>
                      </InputGroup>
                    </Col>
                  </Row>
                </FormGroup>
                <FormGroup>
                  <Row class="g-sm-3 mb-0">
                    <Col sm="3">
                      <Label class="col-form-label text-end">{DisabledDaysoftheWeek}</Label>
                    </Col>
                    <Col xl="5" lg="8" sm="7">
                      <InputGroup>
                          <DateInput bind:value={date} />
                          <InputGroupText><i class="fa fa-calendar"> </i></InputGroupText>
                      </InputGroup>
                    </Col>
                  </Row>
                </FormGroup>
              </Form>
            </div>
          </Col>
        </Row>
      </div>
    </Card>
</Container>